import { render, staticRenderFns } from "./awesomeSwiper.vue?vue&type=template&id=ee585f7e&"
import script from "./awesomeSwiper.vue?vue&type=script&lang=js&"
export * from "./awesomeSwiper.vue?vue&type=script&lang=js&"
import style0 from "./awesomeSwiper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports